import { IFaq } from '../interfaces';
import AxiosService from '../utils/axios-service';

export class FaqService extends AxiosService {
  private static instance: FaqService;

  constructor() {
    super('BFF_HELP_CENTER_URL');
  }

  static get getInstance(): FaqService {
    if (!FaqService.instance) {
      FaqService.instance = new FaqService();
    }
    return FaqService.instance;
  }

  public async findAll(optionId: string): Promise<any> {
    try {
      const url: string = 'faq/findAll';
      const response: IFaq[] = await this.axios.post(url, { status: true, optionId });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default FaqService.getInstance;
